<template>
    <v-footer color="#e99922" class="pa-0 justify-center" fixed dark max-width="100vw">
        <contact-us responsive></contact-us>
        <v-img src="@/assets/logo.png" height="30px" contain class="ma-0 pa-0 mr-2" max-width="30px"></v-img>
        <strong>Ludi Health {{getYear}}</strong>
        <mentions-legales></mentions-legales>
        <v-btn text dark :to="{name:'aboutus'}" v-if="$vuetify.breakpoint.mdAndUp">Qui sommes nous ?</v-btn>
    </v-footer>
</template>

<script>
    import ContactUs from "./ContactUs";
    import MentionsLegales from "./MentionsLegales";
    export default {
        name: "FooterApp",
        components: {MentionsLegales, ContactUs},
        computed:{
            getYear(){
                var aujd = new Date();
                return aujd.getFullYear();
            }
        }
    }
</script>

<style scoped>

</style>